/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./grid.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Children } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
var gutter = "var(--ds-space-negative-050, -4px)";
var listStyles = null;
var listStylesFlagged = null;
var listItemStyles = null;
var Grid = function Grid(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    label = _ref['aria-label'];
  return /*#__PURE__*/React.createElement("ul", {
    "data-testid": testId,
    "aria-label": label,
    className: ax(["_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t", fg('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"])
  }, Children.map(children, function (child) {
    return child && /*#__PURE__*/React.createElement("li", {
      className: ax(["_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"])
    }, child);
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Grid;